import { Breakpoint } from '@mui/material/styles';
import { useContext, createContext, RefObject } from 'react';

export type GlobalLayoutContext = {
  getViewBreakpoint: () => string;
  initViewContainer: (viewContainerRef: RefObject<HTMLDivElement>) => void;
  isViewDown: (breakpoint: Breakpoint) => boolean;
  isViewUp: (breakpoint: Breakpoint) => boolean;
  view: {
    breakpoint: Breakpoint;
    isMobile?: boolean;
    width: number;
  };
};

export const globalLayoutContext = createContext<
  GlobalLayoutContext | undefined
>(undefined);

export function useGlobalLayoutContext() {
  const layoutContext = useContext(globalLayoutContext);
  if (!layoutContext) {
    throw new Error(
      'globalLayoutContext value is undefined. Make sure you use the GlobalLayoutProvider before using the context.'
    );
  }
  return layoutContext;
}
